import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["ontos-section", {'ontos-section--flush': _ctx.flush}])
  }, [
    (_ctx.divider)
      ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.header)
      ? (_openBlock(), _createBlock(_component_ontos_page_header, {
          key: 1,
          title: _ctx.title,
          subtitle: _ctx.subtitle,
          icon: _ctx.icon,
          level: _ctx.level,
          dense: _ctx.dense
        }, _createSlots({ _: 2 }, [
          (_ctx.$slots.title)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                ]),
                key: "0"
              }
            : undefined,
          (_ctx.$slots.subtitle)
            ? {
                name: "subtitle",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
                ]),
                key: "1"
              }
            : undefined,
          (_ctx.$slots.tabs)
            ? {
                name: "tabs",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "tabs", {}, undefined, true)
                ]),
                key: "2"
              }
            : undefined,
          (_ctx.$slots.actions)
            ? {
                name: "actions",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
                ]),
                key: "3"
              }
            : undefined,
          (_ctx.$slots.controls)
            ? {
                name: "controls",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
                ]),
                key: "4"
              }
            : undefined,
          (_ctx.$slots.below)
            ? {
                name: "below",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "below", {}, undefined, true)
                ]),
                key: "5"
              }
            : undefined
        ]), 1032, ["title", "subtitle", "icon", "level", "dense"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}